import {
  buildChatFlowWavePath,
  CHAT_FLOW_VIEW_BOX,
  CHAT_FLOW_WAVE_OPACITIES,
  CHAT_FLOW_WAVE_RUNTIME,
  chatFlowWaveScaleAtMs,
} from 'components/@home/@settings/Tabs/Agents/chatFlowWaveAnimation';
import { string } from 'prop-types';
import React, { useEffect, useRef } from 'react';

const AnimatedChatFlowIcon = ({ className = '' }) => {
  const pathRefs = useRef([]);
  const rafRef = useRef(null);

  useEffect(() => {
    const paths = pathRefs.current;
    const startTime = performance.now();

    const tick = ms => {
      CHAT_FLOW_WAVE_RUNTIME.forEach((wave, index) => {
        const path = paths[index];
        if (!path) return;
        const scale = chatFlowWaveScaleAtMs(ms, startTime, wave);
        path.setAttribute('d', buildChatFlowWavePath(wave.def, scale));
      });

      rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);

    return () => {
      if (rafRef.current != null) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, []);

  return (
    <svg
      className={className}
      viewBox={CHAT_FLOW_VIEW_BOX}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={14}
      >
        {CHAT_FLOW_WAVE_RUNTIME.map((wave, index) => (
          <path
            key={index}
            ref={el => {
              pathRefs.current[index] = el;
            }}
            opacity={CHAT_FLOW_WAVE_OPACITIES[index]}
            d={buildChatFlowWavePath(wave.def, 1)}
          />
        ))}
      </g>
    </svg>
  );
};

AnimatedChatFlowIcon.propTypes = {
  className: string,
};

export default AnimatedChatFlowIcon;
